import "./setWebpackPublicPath";
import iNoBounce from "inobounce";
import "./global.css";
import anchorToProduct from "./anchorToProduct";
import setupStore from "./setupStore";
import setupFeatures from "./setupFeatures";
import setupAnalytics from "../analytics/setup";
import bootstrapReact from "./bootstrapReact";

iNoBounce.disable();
anchorToProduct();
const store = setupStore();
setupFeatures(store);
setupAnalytics(store);
bootstrapReact(store);
